import { render, staticRenderFns } from "./Todos.vue?vue&type=template&id=c8a2732c"
import script from "./Todos.vue?vue&type=script&lang=js"
export * from "./Todos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports